<template>
  <div>
    <v-app-bar
      dense
      color="blue darken-2"
      dark
    >
      <v-toolbar-title class="d-none d-sm-block">Considering Request</v-toolbar-title>
    </v-app-bar>
    <v-spacer></v-spacer>
    <div
      class="card-container"
    >
      <v-card
        v-if="!notFound && requestPayload"
        class="px-4"
        min-width="600px"
      >
        <v-card-title>{{ requestPayload.Requester }} - {{ requestData.Title }} request</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-data-table
            mobile-breakpoint="0"
            :headers="tableHeaders"
            :items="tableData"
            hide-default-footer
            hide-default-header
            :items-per-page="-1"
          >
            <template v-slot:[`item.value`]="{ item }">
              <span
                v-if="item.key === 'Status'"
                :class="getStatusClass(item.value)"
              >
                {{ item.value }}
              </span>
              <a
                v-else-if="item.key === 'File Name'"
                @click="downloadDocument"
              >
                {{ item.value }}
              </a>
              <span v-else>{{ item.value }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-overlay :value="loading">
        <v-progress-circular
          indeterminate
          size="40"
        ></v-progress-circular>
      </v-overlay>
      <v-dialog
        v-model="rejectionDialog"
        max-width="400"
        persistent
      >
        <v-card>
          <v-card-title>
            Request rejection
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-textarea
              rows="2"
              label="Rejection reason"
              v-model="rejectionReason"
            ></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              color="red darken-2 white--text"
              :disabled="!rejectionReason"
              @click="considerRequest"
            >
              Reject
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showEquipmentAdditionalApprovalDialog"
        max-width="500"
        persistent
      >
        <v-card>
          <v-card-title class="text-h6">Additional approval</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <p>Does this request require additional approval (expensive equipment)?</p>
            <v-radio-group v-model="equipmentAdditionalApprovalChoice">
              <v-radio label="No, approve now" value="no"></v-radio>
              <v-radio label="Yes, request additional approval" value="yes"></v-radio>
            </v-radio-group>
            <v-select
              v-if="equipmentAdditionalApprovalChoice === 'yes'"
              v-model="equipmentAdditionalApproverId"
              :items="equipmentAdditionalApproversList"
              item-value="Employee_ID"
              item-text="Employee_Full_Name"
              label="Choose Additional Approver"
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="cancelEquipmentAdditionalApproval">Cancel</v-btn>
            <v-btn
              small
              color="success"
              :disabled="!equipmentAdditionalApprovalChoice || (equipmentAdditionalApprovalChoice === 'yes' && !equipmentAdditionalApproverId)"
              @click="confirmEquipmentApproval"
            >Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div v-if="notFound">Not Found</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConsiderRequestFromEmail',
  data () {
    return {
      downloadLink: document.createElement('a'),
      isRequestProcessed: false,
      token: null,
      action: null,
      requestPayload: null,
      requestData: null,
      showEquipmentAdditionalApprovalDialog: false,
      equipmentAdditionalApprovalChoice: null,
      equipmentAdditionalApproverId: null,
      equipmentAdditionalApproversList: [
        { Employee_ID: 2, Employee_Full_Name: 'Dima Semensky - CEO' },
        { Employee_ID: 13, Employee_Full_Name: 'Vitaliy Matvisiv - Director of Tech Support Department' }
      ],
      rejectionReason: '',
      rejectionDialog: false,
      availableActions: {
        approve: 'approve',
        reject: 'reject'
      },
      modes: {
        absence: 'absence',
        l_and_d: 'l_and_d',
        bonus: 'bonus',
        refund: 'refund',
        equipment_replacement: 'equipment_replacement'
      },
      notFound: false,
      loading: false,
      tableHeaders: [
        {
          text: '',
          value: 'key',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap font-weight-bold'
        },
        {
          text: '',
          value: 'value',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  async mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlParams.entries())

    this.token = params.token || null
    this.action = params.action || null

    if (!this.token || !this.action || !Object.values(this.availableActions).includes(this.action)) {
      this.notFound = true
      return
    }

    await this.checkRequestStatus()
    if (this.isRequestProcessed || this.notFound) {
      return
    }

    if (this.action === this.availableActions.approve) {
      if (this.requestData.Is_Pending && !this.requestData.Request_Data_Table.Updated) {
        if (this.isEquipmentMainApprover()) {
          this.showEquipmentAdditionalApprovalDialog = true
        } else {
          this.considerRequest()
        }
      } else if (this.modes[this.requestData.Request_Type] === 'equipment_replacement' && !this.requestData.Is_Pending && this.action === this.availableActions.approve) {
        this.considerRequest()
      }
    } else if (this.action === this.availableActions.reject) {
      this.rejectionDialog = true
    }
  },
  computed: {
    tableData () {
      return Object.entries(this.requestPayload)
        .map(([key, value]) => {
          if (value) {
            return {
              key,
              value
            }
          }
        })
        .filter(item => !!item)
    }
  },
  methods: {
    getStatusClass (status) {
      if (status === 'Approved') {
        return 'success--text darken-2'
      } else if (status === 'Rejected') {
        return 'error--text darken-2'
      }
      return 'orange--text darken-2'
    },

    async checkRequestStatus () {
      this.loading = true
      await this.axios.get(`/api/emails/check_request_status/${this.token}`)
        .then(response => {
          this.isRequestProcessed = !!response.data[0].Request_Data_Table.Updated
          this.requestData = response.data[0]
          this.requestPayload = response.data[0].Request_Data_Table
          this.loading = false
        }).catch((error) => {
          this.notFound = true
          this.loading = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
    },

    considerRequest (extraPayload = {}) {
      const {
        Title,
        Message
      } = this.generateNotificationData()
      const customTitle = extraPayload.Notification_Title ?? Title
      const customMessage = extraPayload.Notification_Message ?? Message
      const requestedAdditionalApproval = Boolean(extraPayload.Request_Additional_Approval)

      this.loading = true
      this.axios.put(`/api/emails/requests_considering/${this.token}`, {
        Action: this.action === this.availableActions.approve ? 1 : 0,
        Rejection_Reason: this.rejectionReason,
        Notification_Title: customTitle,
        Notification_Message: customMessage,
        ...extraPayload
      }).then(() => {
        this.requestData.Is_Pending = requestedAdditionalApproval ? 1 : false
        this.requestData.Request_Data_Table = {
          ...this.requestData.Request_Data_Table,
          Status: this.action === this.availableActions.approve
            ? (requestedAdditionalApproval ? 'Pending (additional approval requested)' : 'Approved')
            : 'Rejected',
          'Rejection Reason': this.action === this.availableActions.reject ? this.rejectionReason : null,
          Updated: 'just now'
        }
        this.requestPayload = { ...this.requestData.Request_Data_Table }
        this.loading = false
        this.rejectionDialog = false
        this.showEquipmentAdditionalApprovalDialog = false
        this.$store.dispatch('setSuccess', { successMsg: 'Request was updated successfully.' })
      }).catch((error) => {
        this.loading = false
        this.rejectionDialog = false
        this.showEquipmentAdditionalApprovalDialog = false
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    isEquipmentMainApprover () {
      if (!this.requestData || this.modes[this.requestData.Request_Type] !== 'equipment_replacement') return false
      const isAdditional = this.requestData.Equipment_Approver_Type === 'additional' ||
        this.requestData.Is_Additional_Approval === true || this.requestData.Is_Additional_Approval === 1
      return !isAdditional
    },
    cancelEquipmentAdditionalApproval () {
      this.showEquipmentAdditionalApprovalDialog = false
      this.equipmentAdditionalApprovalChoice = null
      this.equipmentAdditionalApproverId = null
    },
    confirmEquipmentApproval () {
      if (this.equipmentAdditionalApprovalChoice === 'yes') {
        const messageRequestType = this.requestData.Title.toLowerCase()
        this.considerRequest({
          Request_Additional_Approval: true,
          Additional_Confirmer_ID: this.equipmentAdditionalApproverId,
          Notification_Title: 'Request pending additional approval',
          Notification_Message: `Your request for ${messageRequestType} approved by main reviewer and sent for additional approval`
        })
      } else {
        this.considerRequest()
      }
      this.equipmentAdditionalApprovalChoice = null
      this.equipmentAdditionalApproverId = null
    },

    downloadDocument () {
      this.loading = true
      this.axios.get(`/api/emails/request_document/${this.token}`, {}).then(res => {
        const fileData = res.data[0]
        this.openFile(fileData.Confirmation_File_Name, fileData.Confirmation_File.data, fileData.Confirmation_File_Type)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },

    openFile (filename, data, type) {
      this.downloadLink.href = this.linkToFile(data, type)
      this.downloadLink.download = filename
      this.downloadLink.click()
      this.loading = false

      setTimeout(() => {
        this.downloadLink.href = ''
      })
    },

    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },

    generateNotificationData () {
      const isRequestApproved = this.action === this.availableActions.approve
      const actionWord = isRequestApproved ? 'approved' : 'rejected'
      const messageRequestType = this.requestData.Title.toLowerCase()
      const consideringNotification = {
        Title: '',
        Message: ''
      }
      if (isRequestApproved && this.modes.l_and_d === this.requestData.Request_Type) {
        consideringNotification.Title = 'Request ' + actionWord
        consideringNotification.Message = `Your ${messageRequestType} request ${actionWord}, please find your request in history and upload payment files (after that financier can approve it)`
      } else if (this.modes.bonus === this.requestData.Request_Type) {
        consideringNotification.Title = 'Request ' + actionWord
        consideringNotification.Message = this.requestPayload.Reviewer + ` has ${actionWord} your bonus request`
      } else {
        consideringNotification.Title = 'Request ' + actionWord
        consideringNotification.Message = 'Your request for ' + messageRequestType + ' ' + actionWord
      }
      return consideringNotification
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-container {
    height: 91vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
